import React from 'react';
import Select from 'react-select'
import clsx from 'clsx';
import { Tooltip, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
// https://react-select.com/styles

const SelectWrapper = styled('div')(({ theme }) => ({
    marginBottom: 20,
    '& .labelWrapper': {
        width: '100%',
        display: 'flex',
    },
    '& .label': {
        color: '#878787',
        flex: 1,
        fontSize: 12,
        margin: 0,
    },
    '& .select': {
        flex: 1,
    },
    '& .padding': {
        padding: '0px',
        '& path': {
            fill: '#6EA0D7'
        }
    },
    '& .option': {
        fontSize: '10px'
    },
    '& .note': {
        color: '#A9A9A9',
        fontSize: '10px',
        textAlign: 'left'
    },
    '& .helpIcon': {
        color: "#0000008a",
        cursor: 'pointer',
        marginLeft: 8,
    },
    '& .helperIconSelectWrapper': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    },
    '& .outlinedSelectContainer': {
        position: 'relative',
        marginTop: 8,
    },
    '& .outlinedLabel': {
        position: 'absolute',
        top: 0,
        left: 8,
        transform: 'translateY(-50%)',
        zIndex: 1,
        padding: '0 4px',
        background: '#fff',
        color: '#878787',
        fontSize: 12,
        lineHeight: 1,
        maxWidth: 'calc(100% - 16px)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    '& .outlinedLabelError': {
        color: 'red',
    }
}));

/**
 * @template P
 * @param {P & {
 *  options: { label: string; value: number|string }
 * }} props
 */
const ReactSelect = (props) => {

    const { onChange, labelText, labelColor, labelClass, selectWrapperClass, labelWrapperClass, customStyles = false, selectClass, target, extraOnChange, error = false, note = null, helpIconText = null, outlinedLabel = false, ...other } = props;
    let AuxStyle = error ?
        {
            ...customStyles,
            control: base => ({
                ...base,
                borderColor: 'red'
            }),
        } : customStyles

    const selectControl = (
        <div className="helperIconSelectWrapper">
            <Select
                className={clsx("select", selectClass)}
                styles={AuxStyle}
                onChange={(selectedValue) => {
                    onChange(target, selectedValue, extraOnChange)
                }}
                hideSelectedOptions={false}
                menuPlacement="auto"
                {...other}
                theme={theme => ({
                    ...theme,
                    borderRadius: 3,
                    borderColor: error ? 'red' : '#E6EDF5',
                    colors: {
                        ...theme.colors,
                        primary: '#E6EDF5',
                    },
                })}
            />

            {helpIconText && (
                <Tooltip
                    title={
                        <>
                            {helpIconText}
                        </>
                    }
                    arrow
                >
                    <InfoIcon
                        className="helpIcon"
                        style={{ width: '15px', height: '15px', fontSize: '15px' }}
                    />
                </Tooltip>
            )}
        </div>
    );

    return (
        <SelectWrapper className={clsx(selectWrapperClass)}>
            {outlinedLabel ?
                <div className="outlinedSelectContainer">
                    {labelText ?
                        <Typography component="span" className={clsx("outlinedLabel", error && "outlinedLabelError", labelClass)}>{labelText}</Typography>
                        : null}
                    {selectControl}
                </div>
                :
                <>
                    {labelText ?
                        <div className={clsx("labelWrapper", labelWrapperClass)}>
                            <Typography className={clsx("label", labelClass)} color={labelColor}>{labelText}</Typography>
                        </div>
                        : ''}
                    {selectControl}
                </>
            }

            <span><small className="note">{note}</small></span>
        </SelectWrapper>
    );
}

export default ReactSelect;
